/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable array-callback-return */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { cloneDeep } from 'lodash';
import { Button } from 'react-bootstrap';
import { ONLINE_CLIENT_TYPE, WebStep } from '@upstart/harmony/lib/constants';
import {
  getDefaultWebFlow,
  getDisabledOnlineSteps,
} from '@upstart/harmony/lib/flow-utils';
import { LeadFormConfig } from '@upstart/harmony/lib/legos/leadFormTypes';
import { Website } from '@upstart/harmony/lib/legos/websiteTypes';
import websiteActions from '../../../redux/websites/actions';

import { FlowList, AvailableList } from '../../FlowList';
import ErrorMessage from '../../ErrorMessage';
import '../Website.scss';
import LeadForm from '../LeadForm';

const PII_IN_FLOW = -1;
const PII_FLOW = {
  id: 'piiInFlow' as WebStep,
  name: 'PII in Flow',
  required: true,
};

function WebsiteTheme(props: any) {
  const { website, dealer, actions, history } = props;
  const [flow, setFlow] = useState<{ id: string | WebStep; name: string }[]>(
    [],
  );
  const [leadForm, setLeadForm] = useState<LeadFormConfig>({});
  const disabledOnlineSteps = getDisabledOnlineSteps(dealer);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    setFlow(website.flow || getDefaultWebFlow());
    setLeadForm(website?.configs?.leadForm ?? {});
  }, [website]);

  useEffect(() => {
    const leadFormAlreadyInFlow = !!flow?.find(({ id }) => id === PII_FLOW.id);
    const wantLeadFormInFlow = leadForm?.piiFlow === PII_IN_FLOW;

    if (wantLeadFormInFlow && !leadFormAlreadyInFlow) {
      setFlow([...flow, PII_FLOW]);
    } else if (leadFormAlreadyInFlow && !wantLeadFormInFlow) {
      setFlow(flow.filter(({ id }) => id !== PII_FLOW.id));
    }
  }, [leadForm]);

  const onFlowChange = (__flowListType: string, updatedFlow: any) => {
    const newFlow = cloneDeep(updatedFlow);
    setErrorMessage('');
    setFlow(newFlow);
  };

  const hasDuplicate = (values: Array<{ id: string; name: string }>) => {
    const valueIdArr = values.map((value) => value.id);
    const valueNameArr = values.map((value) => value.name);
    return (
      valueIdArr.some((item, idx) => valueIdArr.indexOf(item) !== idx) ||
      valueNameArr.some((item, idx) => valueNameArr.indexOf(item) !== idx)
    );
  };

  // eslint-disable-next-line consistent-return
  const onSave = async () => {
    const newFlow = cloneDeep(flow);
    const newWebsite: Website = cloneDeep(website);

    if (hasDuplicate(newFlow)) {
      setErrorMessage('There are duplicate steps in the flow');
      return;
    }
    // TODO: Vaidation Rules
    newWebsite.flow = newFlow;
    newWebsite.configs = { ...(newWebsite?.configs ?? {}), leadForm };
    actions.updateWebsiteRequest({ website: newWebsite });
  };

  const cancel = () => {
    history.push('/websites/');
  };

  if (!website.id || !dealer) {
    return null;
  }

  return (
    <div className="website-tab-container flow-tab">
      {errorMessage && <ErrorMessage error={errorMessage} />}
      <div className="flow-container">
        <FlowList
          flow={flow}
          flowListType={ONLINE_CLIENT_TYPE.WEB}
          dealer={dealer}
          onChange={onFlowChange}
        />
        <AvailableList
          flow={flow}
          flowListType={ONLINE_CLIENT_TYPE.WEB}
          onChange={onFlowChange}
          disabledSteps={disabledOnlineSteps}
        />
      </div>

      <LeadForm leadForm={leadForm} onChange={setLeadForm} />
      <div className="flow-button-container">
        <Button
          className="btn btn-secondary"
          type="button"
          onClick={() => cancel()}
        >
          Cancel
        </Button>
        <Button
          className="btn btn-primary"
          type="button"
          onClick={() => onSave()}
        >
          Save
        </Button>
      </div>
    </div>
  );
}

WebsiteTheme.propTypes = {
  website: PropTypes.object,
  actions: PropTypes.object,
  dealer: PropTypes.object,
};

const mapStateToProps = (state: any) => ({
  website: state.websites.website,
});

const mapDispatchToProps = (dispatch: Dispatch<{}>) => ({
  actions: bindActionCreators(
    {
      ...websiteActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(WebsiteTheme);
